import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import CommonUtil from "../../../common/commonUtil";
import Const from "../../../const/Const";
import { sendSmsEstheticReservation, setReserve } from '../../../const/index';
import MessageConst from '../../../const/messageConst';
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from '../../atoms/label';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { EstheticInputList } from "../../molecules/estheticInputList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/inputUser.css';

const EstheticConfirmUserContainer = (props) => {
    const {
        state,
        login,
        estheRsvInfo,
        setEstheRsvInfo,
        estheticInfo,
        prevScreenInfo,
        setLoginFlg,
        setLinkParameter,
        onClickOpenPopupWindow
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    // const loginUserInfo = store.getState().login.loginUserInfo;

    // 2度押し制御用フラグ
    let clickFlg = false;

    const isCrawl = store.getState().login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;

    /** CRAWL用ユーザー情報設定 */
    const userInfo = isCrawl && crawlMember ?
        {
            syainNo: crawlMember.syain_no,
            uketukeCd: crawlMember.uketuke_cd,
            uketukeBashoCd: crawlMember.uketukebasyo_cd,
        } : null;

    const [linkList, setLinkList] = useState([]);
    // プロパティ一覧

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [temporaryErrorInfo, setTemporaryErrorInfo] = useState({ errorMessage: "", errorFlg: false, });
    const [flgList, setFlgList] = useState(false);
    const [illegalFlg, setIllegalFlg] = useState(false);

    // rtoasterタグ生成
    const customParam = {
        "sisetucd": estheRsvInfo.shisetsuCd,
        "riyodat": estheRsvInfo.riyoDate,
        "menucd": estheRsvInfo.mainCourseList?.length ? estheRsvInfo.mainCourseList[0].courseCd : "",
        "jikan": estheRsvInfo.yoyakuTime,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        // let state = store.getState().login;
        // let apiKey = null;
        // if (Object.keys(state).length !== 0) {
        //     apiKey = state.apiKey;
        // }
        // if (apiKey === null) {
        //     store.dispatch({ type: "CLEAR_STATE" });
        //     history.push("/reserve/login");
        // }
        // if (apiKey) {
        //     common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        // }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        // common.doPost(versionGetApi, {}, afterVerCheck);
        if (prevScreenInfo && prevScreenInfo.currentPath.indexOf("hotel/facilityReserveComplete") != -1) {
            history.goBack();
        }else if (Object.keys(estheRsvInfo).length == 0 || Object.keys(estheticInfo).length == 0) {
            setIllegalFlg(true);
        } else {
            if (estheRsvInfo.loginFlg) {
                setLoginFlg(true);
                setLinkList([
                    { path: `/reserve/hotel/facilityReserve/`, label: "お客様情報入力" },
                ]);
            } else {
                setLinkList([
                    { path: `/reserve/hotel/facilityReserve/${estheRsvInfo.shisetsuCd}/${estheRsvInfo.estheticCd}`, label: "お客様情報入力" },
                ]);
                setLinkParameter(estheticInfo.shisetsuCd, estheticInfo.estheticCd);
            }
        }
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        if (estheRsvInfo.loginFlg) {
            history.push(`/reserve/hotel/facilityReserve/`);
        } else {
            history.push(`/reserve/hotel/facilityReserve/${estheRsvInfo.shisetsuCd}/${estheRsvInfo.estheticCd}`);
        }
    }

    // 予約後処理
    const afterSetReserve = (res) => {
        let errorMessage = "";
        let errorFlg = false;
        let data = res.data;
        if (data.resultCode == 0) {
            setEstheRsvInfo({ ...estheRsvInfo, yoyakuNo: data.yoyakuNo, estheticUrl: data.estheticUrl, successSmsFlg: data.successSmsFlg });
            history.push("/reserve/hotel/facilityReserveComplete");
        } else {
            errorMessage = data.errorMessage;
            errorFlg = true;
            clickFlg = false;
        }
        setTemporaryErrorInfo({ errorMessage: errorMessage, errorFlg: errorFlg })
    }

    // 「この内容で予約する」ボタン押下時
    const onClickReserve = () => {
        if (!clickFlg) {
            clickFlg = true;
            let req = {
                shisetsuCd: estheRsvInfo.shisetsuCd,
                shisetsuName: estheRsvInfo.shisetsuName,
                keiyakuNo: estheRsvInfo.keiyakuNo,
                pointKaiinId: estheRsvInfo.loginFlg && login?.memberCode ? login.memberCode : "",
                registFlg: true,
                riyoKaiinkenSyubetCd: estheRsvInfo.riyoKaiinkenSyubetCd,
                riyoDate: estheRsvInfo.riyoDate,
                daihyouNameKana: estheRsvInfo.daihyouNameKana,
                daihyouName: estheRsvInfo.daihyouName,
                mainPhoneKbn: estheRsvInfo.mainPhoneKbn,
                mainPhoneNumber: estheRsvInfo.mainPhoneNumber,
                contactPhoneKbn: estheRsvInfo.contactPhoneKbn,
                contactPhoneNumber: estheRsvInfo.contactPhoneNumber,
                contactMailAddress: estheRsvInfo.contactMailAddress,
                relationCd: estheRsvInfo.relationCd,
                kozafurikaeFlg: estheRsvInfo.kozafurikaeFlg,
                biko: estheRsvInfo.biko,
                kakuninMailKiboKbn: estheRsvInfo.kakuninMailKiboKbn,
                kakuninMailAddress: estheRsvInfo.confirmReserveMail,
                gairaiList: estheRsvInfo.gairaiList,
                gairaiCourseList: estheRsvInfo.gairaiCourseList,
                allergyKbn: "2", // 2:無し 固定
                hakuCnt: 0,
                carCnt: 0,
                importedFlg: true, /* 外来フラグ　固定値 */
                userInfo,
                changeFlg: estheticInfo.changeFlg,
                yoyakuNo: estheRsvInfo.yoyakuNo ? estheRsvInfo.yoyakuNo : "",
                gairaiRsvKbn: estheRsvInfo.gairaiRsvKbn,
                estheticNumber: estheRsvInfo.estheticNumber
            };

            common.doPost(setReserve, req, afterSetReserve);
        }
    }


    return (
        <div className="userInputInnerWrapper">
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="入力内容確認"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            {illegalFlg ? 
                <div className="reserveInputWrapper">
                    <Label
                        label={MessageConst.ILLEGAL_ACCESS_ERROR}
                        style={styles.illegalDiv}
                    />
                </div>
                :
                <>
                    <div className="reserveInputWrapper">
                        <Label
                            label={MessageConst.NOT_YET_COMPLETED_MESSAGE}
                            style={styles.notYetCompleted}
                        />
                        <Label
                            label={isWideTablet ? MessageConst.CONFIRM_MESSAGE_SP : MessageConst.CONFIRM_MESSAGE}
                            className="confirmMessage"
                        />
                        <div className={"reserveInfo"}>
                            <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                                <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                            </div>
                            <Label
                                label={"ご予約内容"}
                                className="reserveInfoTitle"
                            />
                            <div className={"inputUserWrap"}>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="ご利用日"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={CommonUtil.getStringFromDateJpn(estheRsvInfo.riyoDate)}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="館内施設名"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={estheticInfo.shisetsuName + "\n" + estheticInfo.estheticName}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className="reserveInfoContentBlock">
                                    <div className="reserveInfoContent">
                                        <Label
                                            label="時間"
                                            className="reserveInfoTitleGray"
                                        />
                                        <Label
                                            label={estheRsvInfo.yoyakuTime ? CommonUtil.getTimeStr(estheRsvInfo.yoyakuTime, "hh:mm") : ""}
                                            className="confirmContentLabel"
                                        />
                                    </div>
                                </div>
                                <div className={estheRsvInfo.optionCourseList?.length > 0 ? "reserveInfoContentBlock" : "reserveInfoContentNonBorder lastContent"}>
                                    <div className={isWideTablet ? "" : "reserveInfoContent"}>
                                        <Label
                                            label="メインメニュー"
                                            className={"reserveInfoTitleGray" + (isWideTablet ? " str_padding" : "")}
                                        />
                                        {estheRsvInfo.mainCourseList ? estheRsvInfo.mainCourseList.map((course, index) =>
                                            <div key={"mainCourse" + index} className="confirmContentLabel">
                                                <Label
                                                    label={course.courseName}
                                                    className="confirmContentLabel"
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                {/* {estheRsvInfo.optionCourseList?.length > 0 ?
                                    <div className="reserveInfoContentNonBorder lastContent">
                                        <div className={isWideTablet ? "" : "reserveInfoContent"}>
                                            <Label
                                                label="オプションメニュー"
                                                className={"reserveInfoTitleGray" + (isWideTablet ? " str_padding" : "")}
                                            />
                                            <div className="confirmContentsBlock">
                                                {estheRsvInfo.optionCourseList ? estheRsvInfo.optionCourseList.map((course, index) =>
                                                    <div key={"optionCourse" + index} className="confirmContents">
                                                        <Label
                                                            label={course.courseName}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    : null
                                } */}
                            </div>
                        </div>
                    </div>
                    {/* エステ予約情報入力フォーム */}
                    <EstheticInputList
                        estheRsvInfo={estheRsvInfo}
                        loginFlg={estheRsvInfo.loginFlg}
                        setEstheRsvInfo={setEstheRsvInfo}
                        titleClassName="titleLabel"
                        flgList={flgList}
                        responsiveFlg={isWideTablet}
                        onClickOpenPopupWindow={onClickOpenPopupWindow}
                        confirmFlg={true}
                    />
                    <div className="btnToConfirmWrapper">
                        <div className="confirmboxWrap">
                            <Button buttonText="戻る" className="btnBack btnSpStyle" onClick={onClickBack} buttonClassName="serachBtnText" />
                            <Button buttonText="この内容で予約する" className="btnReserveOrCredit" onClick={onClickReserve} buttonClassName="serachBtnText" />
                        </div>
                    </div>
                </>
            }
            <div style={temporaryErrorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                <ErrorMassage style={styles.errorMassage} data={[temporaryErrorInfo.errorMessage]} />
            </div>
            {/* <div className="backTopInput">
                <Link to={"/reserve/top"} style={styles.bottomLink}>TOPへ戻る</Link>
            </div> */}
            <div style={styles.footer}>
                <MembershipFooterContainer className={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        estheRsvInfo: state.estheRsvInfo,
        estheticInfo: state.estheticInfo,
        prevScreenInfo: state.prevScreenInfo
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setEstheRsvInfo: (item) => {
            dispatch({ type: "ESTHE_RSV_INFO", payload: { estheRsvInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(EstheticConfirmUserContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        backgroundColor: "rgba(255, 255, 255, 0.94)",
        border: 0,
        fontWeight: "bold"
    },
    illegalDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    notYetCompleted: {
        color: "red",
        fontSize: "12.8px",
        letterSpacing: "2px",
        paddingBottom: "10px",
        fontWeight: "bold",
        textAlign: "center",
    },
}
